import { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { BasePageContent } from '../../model/content';
import { replaceTemplate } from 'gocclr-shared-ui/dist/helpers/text-helper';
import { getSiteName, getUser } from '../../app-context/accounts-context';

export interface PageHeadProps extends BasePageContent {
}

export function PageHead(props: PropsWithChildren<PageHeadProps>) {
    const user = getUser();
    const siteName = getSiteName();

    const titleTemplateData = { username: user?.username || '', siteName: siteName, userFistName: user?.firstName || '', userFullName: user?.formattedName || '' };
    return (
        <>
            <Helmet>
                {props.pageTitle && <title>{replaceTemplate(props.pageTitle, titleTemplateData)}</title>}
                {props.pageDescription && <meta name="description" content={props.pageDescription} />}
            </Helmet>
            {props.children}
        </>
    );
}
